module.exports = "li {\r\n    list-style-type: none;\r\n    display: inline-block;\r\n}  "


//////////////////
// WEBPACK FOOTER
// ./src/app/cards/cards.component.css
// module id = ./src/app/cards/cards.component.css
// module chunks = main